'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactHotLoader = require('react-hot-loader');

var _store = require('store');

var _store2 = _interopRequireDefault(_store);

var _stores = require('./stores');

var _AppState = require('./lib/AppState');

var _AppState2 = _interopRequireDefault(_AppState);

var _App = require('./App');

var _App2 = _interopRequireDefault(_App);

var _Transport = require('./utils/Transport');

var _Transport2 = _interopRequireDefault(_Transport);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var APP_HASH_KEY = '_v',
    CURRENT_APP_HASH = window.Mighty.APP_HASH,
    PREVIOUS_APP_HASH = _store2.default.get(APP_HASH_KEY),
    transport = new _Transport2.default({
  baseUrl: window.Mighty.API_HOST + '/api/v1',
  headers: {}
});

global.HAS_APP_VERSION_CHANGED = CURRENT_APP_HASH !== PREVIOUS_APP_HASH;
_store2.default.set(APP_HASH_KEY, CURRENT_APP_HASH);

// in node 14+, can just use await in a top-level module
// but in node 10, have to create this wrapper
_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
  return regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return _AppState2.default.init(_stores.CaseStoreClass, _stores.SessionStoreClass, transport);

        case 2:
        case 'end':
          return _context.stop();
      }
    }
  }, _callee, undefined);
}))();

window.AppState = _AppState2.default;
(0, _reactDom.render)(_react2.default.createElement(_App2.default, { AppState: _AppState2.default }), window.document.getElementById('root'));

if (module.hot) {
  module.hot.accept('./App', function () {
    var NextApp = require('./App').default;

    (0, _reactDom.render)(_react2.default.createElement(
      _reactHotLoader.AppContainer,
      null,
      _react2.default.createElement(NextApp, { AppState: _AppState2.default })
    ), window.document.getElementById('root'));
  });
}
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(APP_HASH_KEY, 'APP_HASH_KEY', '/app/src/index.js');
  reactHotLoader.register(CURRENT_APP_HASH, 'CURRENT_APP_HASH', '/app/src/index.js');
  reactHotLoader.register(PREVIOUS_APP_HASH, 'PREVIOUS_APP_HASH', '/app/src/index.js');
  reactHotLoader.register(transport, 'transport', '/app/src/index.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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